import React, { Component } from 'react';
import { Button, Table, Popconfirm, Input, message, Select, Tag, Row, Col, Card, DatePicker, Typography } from 'antd'

import { PlusOutlined, MinusOutlined, ReloadOutlined, SendOutlined, PrinterOutlined, CloseOutlined } from '@ant-design/icons';


import ReactToPrint from "react-to-print";

import { inject, observer } from 'mobx-react';

import _, { find } from 'lodash';
import moment from 'moment';
import NavbarPanel from '../components/NavbarPanel';
import { LoadingGlobal } from '../components/LoadingGlobal';
//moment.locale('tr')
//import 'moment/locale/tr';

//Yazdırnma
import ComponentToPrint from '../components/ToPrint'
import { toJS } from 'mobx';
import { date2DD, formatMyMoney } from '../helper';


const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;


@inject('HourseBetStore', 'UserStore')
@observer
export default class Coupon extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modalVisible: true,
            couponcode: '',
            user: 'all',
            start: new Date(),
            end: new Date(),
            ctype: 'all',
            status: 'all',
        }

    }

    componentDidMount() {


        const t = new Date().getDate() + (5 - new Date().getDay() - 1) - 7;
        const lastFriday = new Date();
        lastFriday.setDate(t);
        console.log({ lastFriday, t });

        //kullanıcıları da set et 
        this.props.UserStore.getUsers();


        this.setState({
            start: lastFriday
        }, () => {
            this.getItemList();
        })




        window.scrollTo(0, 0)
    }

    /*
                start: new Date(start).setHours(0, 0),
            end: new Date(end).setHours(24, 59),
            */
    getItemList = async (obj) => {
        const { couponcode, user, start, end, ctype, status } = this.state

        const action = _.get(obj, "action")

        let filtered = {
            couponcode,
            user,
            start: new Date(start),
            end: new Date(end),
            ctype,
            status,
            action
        }

        try {
            let serverData = await this.props.HourseBetStore.listCouponReportDay(filtered);
            console.log({ serverData })
        } catch (error) {
            console.log(error)
        }
        finally {
            // this.setState({ loading: false })
        }

    }

    onChangeSelect = (e, type) => {

        this.setState({
            [type]: e
        }, () => {
            this.getItemList()
        })

    }

    resetState = () => {
        this.setState({
            couponcode: '',
            user: 'all',
            start: new Date(),
            end: new Date(),
            ctype: 'all',
            status: 'all',
        }, () => {
            this.getItemList()
        })
    }


    onChangeDatePicker = (dates, dateStrings, type) => {
        // dateStrings
        console.log({ dates, dateStrings, dd: new Date(dates) })


        if (!dates) {
            this.setState({
                [type]: new Date()
            }, () => {
                this.getItemList()
            })
        }
        else {
            this.setState({
                [type]: new Date(dates)
            }, () => {
                this.getItemList()
            })
        }



    }

    onClickCancel = (record) => {
        //   const record = item.runs[0]
        if (date2DD({ TARIH: record.runs[0].TARIH, SAAT: record.runs[0].SAAT, setMinute: true }) <= new Date()) {
            message.warn("Başlamış koşu iptal edilemez!")
            return
        }
        this.onCancelService(record)
    }


    onCancelService = async (data) => {
        this.setState({ loading: true })
        try {
            const serverData = await this.props.HourseBetStore.remove(data)
            const newBalance = _.get(serverData, "newBalance", 0)
            const id = _.get(serverData, "_id")
            this.props.UserStore.setUserBalance(newBalance)

            this.props.HourseBetStore.splice(id)

            console.log("onCancelService", { serverData })
            message.success()
        } catch (error) {
            console.log({ error })
        }
        finally {
            this.setState({ loading: false })
        }
    }

    onBeforePrint = (item) => {
        console.log("onBeforePrint", item)
        this.setState({ ...item })
    }
    onAfterPrint = () => {
        console.log("onAfterPrint")
    }


    // Net kazancı hesapla
    getNetPrice = (record) => {
        return (((Number(record.price)
            -
            Number(
                _.sumBy(_.filter(record.main, { status: 1 }), (o) => {
                    return o.gainPrice ? o.gainPrice : 0
                })
            )
        )))
    }


    render() {
        //değişkenler vs

        const loading = _.get(this.props, "HourseBetStore.loading", false)
        const data = _.get(this.props, "HourseBetStore.couponsReportDay", [])

        const activeUserType = _.get(this.props.UserStore, "user.userType", 4)

        const { users } = this.props.UserStore

        const dateFormat = 'DD/MM/YYYY';
        const dateFormatTime = 'DD/MM/YYYY HH:mm';

        const columns = [
            {
                title: 'Tarih',
                key: 'user',
                render: (text, record) =>
                    <span>
                        {
                            // const moment1 = moment(`${TARIH}`, "DD/MM/YYYY")
                            //  const date = moment1.toDate()
                            moment(record.created).format("DD.MM.YYYY")
                            // {_.get(record, "user.username")}
                        }

                    </span>

            },
            {
                title: 'Yatırılan',
                key: 'detail',
                render: (text, record) => <span>

                    <b>  {
                        formatMyMoney(record.price)
                    } ₺</b>
                    {` `}
                    ({record.count})
                </span>
            },
            {
                title: 'Kazanılan',
                key: 'kfdo',
                render: (text, record) => <span>

                    <b>  {

                        formatMyMoney(_.sumBy(_.filter(record.main, { status: 1 }), (o) => {
                            return o.gainPrice ? o.gainPrice : 0
                        }))

                    } ₺</b>
                </span>
            },
            {
                title: 'Sonuç',
                key: 'result',
                render: (text, record) =>
                    <span style={{ color: this.getNetPrice(record) > 0 ? "green" : "red", fontWeight: 'bolder' }}>
                        {
                            formatMyMoney(this.getNetPrice(record))

                        }
                        ₺
                    </span>
            },
        ];




        return (
            <div>
                <NavbarPanel page="report" />
                <LoadingGlobal loading={loading} />
                <Card
                    bordered={false}
                >
                    <Table
                        bordered={true}
                        rowKey={'_id'}
                        loading={loading}
                        columns={columns}
                        pagination={false}
                        dataSource={data}
                        size='small'
                        title={() => <span>
                            <div style={{
                                backgroundColor: '#FFF',
                                // padding: '24px 0' 
                            }}>
                                <Row style={{ backgroundColor: '#fff', fontWeight: 'normal', fontSize: 12 }} >
                                    <Col span={8} className={"pr-10"}>
                                        <span style={{ fontSize: 14 }}>
                                            Günlük Rapor
                                 </span>
                                        {
                                            // <h3>Rapor Detay</h3>
                                        }
                                    </Col>
                                    <Col span={4} className={"pr-10"}>
                                        {
                                            /**
                                             *                     <span>
                                                                <p className={"mb-0"}>
                                                                  Yenile
                                                                      </p>
                                          
                                                                <Button
                                                                  // size="small"
                                                                  block
                                                                  type='ghost'
                                                                  // shape='circle-outline'
                                                                  icon={<ReloadOutlined />}
                                                                  onClick={() => this.resetState()}
                                                                >Yeniden Yükle</Button>
                                                              </span>
                                             */
                                        }
                                    </Col>
                                    <Col span={4} className={"pr-10"}>
                                        {
                                            activeUserType != 4
                                            &&
                                            <>
                                                <p className={"mb-0"}>
                                                    Kullanıcı</p>
                                                <Select className={"w100"} value={this.state.user} onChange={(e) => this.onChangeSelect(e, "user")} >
                                                    <Option value={"all"}>Tümü</Option>
                                                    {
                                                        users.map((v, i) => {
                                                            return (
                                                                <Option key={i} value={v._id}>{v.username}</Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </>
                                        }
                                    </Col>
                                    <Col span={4} className={"pr-10"}>
                                        <p className={"mb-0"}>
                                            İlk Tarih</p>
                                        <DatePicker
                                            value={moment(this.state.start, dateFormat)}
                                            format={dateFormat}
                                            onChange={(v, dateString) => this.onChangeDatePicker(v, dateString, "start")}
                                            className={"w100"}
                                        />
                                    </Col>
                                    <Col span={4}
                                    // className={"pr-10"}
                                    >
                                        <p className={"mb-0"}>
                                            Son Tarih</p>
                                        <DatePicker
                                            value={moment(this.state.end, dateFormat, "end")}
                                            onChange={(v, dateString) => this.onChangeDatePicker(v, dateString, "end")}
                                            format={dateFormat}
                                            className={"w100"} />
                                    </Col>

                                </Row>
                            </div>

                        </span>}
                        footer={() => <div className="ant-table-content">
                            <table style={{ tableLayout: 'auto' }}>
                                <tbody className="ant-table-tbody">
                                    <tr className="ant-table-row ant-table-row-level-0">
                                        <td className="ant-table-cell ww1200">&nbsp;</td>
                                        <td className="ant-table-cell ww1200">
                                            {
                                                formatMyMoney(_.sumBy(data, "price"))
                                            } ₺
                                            {` `}
                                          ({_.sumBy(data, "count")})
                                          </td>
                                        <td style={{ paddingLeft: 60 }} className="ant-table-cell ww1200">
                                            {

                                                formatMyMoney(_.sumBy(data, (record) => {
                                                    return _.sumBy(_.filter(record.main, { status: 1 }), (o) => {
                                                        return o.gainPrice ? o.gainPrice : 0
                                                    })
                                                }))

                                            } ₺
                                          </td>
                                        <td className="ant-table-cell ww1200" style={{ paddingLeft: 60, color: _.sumBy(data, (record) => { return this.getNetPrice(record) }) > 0 ? "green" : "red", fontWeight: 600 }}>
                                            {
                                                formatMyMoney(_.sumBy(data, (record) => {
                                                    return this.getNetPrice(record)
                                                }))
                                            }  ₺
                                          </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>}
                    />

                </Card>
            </div>
        )
    }
}